import { useFieldArray } from 'react-final-form-arrays';

import { FWorkflowTriggerFragment } from '@dashboard/generated/wp/platform';

export default function useTriggersMutator() {
  return useFieldArray<FWorkflowTriggerFragment>('triggers');
}
